import React from 'react';
import { Icon } from '@sb1/ffe-icons-react';
export var ContextMessageIcon = function (_a) {
    var smallIconUrl = _a.smallIconUrl, largeIconUrl = _a.largeIconUrl;
    return (React.createElement(React.Fragment, null,
        React.createElement(Icon, { fileUrl: smallIconUrl, className: "ffe-context-message-content__icon-span ffe-context-message-content__icon-span--small", size: "sm" }),
        React.createElement(Icon, { fileUrl: largeIconUrl, className: "ffe-context-message-content__icon-span ffe-context-message-content__icon-span--large", size: "lg" })));
};
